export const SIDE_MENU_TOGGLE_MUTATION = "SIDE_MENU_TOGGLE_MUTATION";
export const SIDE_MENU_OPEN_MUTATION = "SIDE_MENU_OPEN_MUTATION";
